import { constants, mediaQueryStyles } from "@newsela/angelou";
const { mediaQuery: mq } = mediaQueryStyles;
const { breakpoints } = constants;
const { BreakpointNames } = breakpoints;

export const modalCss = {
  root: {
    zIndex: 10,
  },
  modalContentWrapper: {
    [mq.downTo(BreakpointNames.xs)]: {
      maxWidth: "800px",
      maxHeight: "622px",
    },
  },
  scrollableBody: {
    [mq.downTo(BreakpointNames.xs)]: {
      height: "420px",
      padding: "32px 32px",
    },
    [mq.upTo(BreakpointNames.xs)]: {
      height: "85%",
    },
  },
  title: {
    margin: "16px 24px 25px 32px",
    fontSize: "24px",
  },
  footer: {
    [mq.upTo(BreakpointNames.xs)]: {
      marginBottom: "80px",
    },
  },
};

export const modalTriggerCss = {
  root: {
    width: "100%",
    marginTop: "1.5rem",
    [mq.downTo(BreakpointNames.sm)]: {
      width: "auto",
    },
  },
};

export const modalFooterCss = {
  display: "flex",
  minHeight: "48px",
  justifyContent: "flex-end",
  alignItems: "center",
  ">*": {
    marginLeft: "8px",
  },
};
